import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { SignOutIcon } from 'src/assets/icons';
import { UI_ROUTES } from 'src/constants/routes';
import { signOutFn } from 'src/utils/sign-out';
import { StyledDarkModeSwitcher, StyledDrawerActions } from './Actions.styled';
import { Button, DarkModeSwitcher } from '../../atoms';
import { NavBarComponentsCommonProps } from '../common';
import { StyledListItem } from '../Links/Links.styled';
import { ProfileBar } from './ProfileBar';

export type NavBarComponentsCommonPropsProps = NavBarComponentsCommonProps;

export const NavBarActions: React.FunctionComponent<NavBarComponentsCommonPropsProps> = ({
  menuIsOpen,
  toggleMenu,
}) => {
  const navigate = useNavigate();
  const handleSignOut = () => {
    signOutFn();
    navigate(UI_ROUTES.LOGIN);
  };
  return (
    <StyledDrawerActions>
      <StyledListItem>
        <StyledDarkModeSwitcher $menuIsOpen={menuIsOpen}>
          <DarkModeSwitcher />
        </StyledDarkModeSwitcher>
      </StyledListItem>
      <StyledListItem $empty>&nbsp;</StyledListItem>
      <StyledListItem>
        <Button onClick={handleSignOut} color="secondary" startIcon={<SignOutIcon />} size="small">
          Sign Out
        </Button>
      </StyledListItem>

      <StyledListItem $empty>&nbsp;</StyledListItem>
      <StyledListItem>
        <ProfileBar menuIsOpen={menuIsOpen} toggleMenu={toggleMenu} />
      </StyledListItem>
    </StyledDrawerActions>
  );
};
